const buildUrl = (suffix) => {
  const base =
    process.env.FRONT_COMMERCE_CLOUD_URL ||
    process.env.FRONT_COMMERCE_URL ||
    "http://localhost:4000";

  return `${base}${suffix}`;
};

module.exports = {
  default: {
    locale: "en-US",
    url: buildUrl(""),
    magentoStoreCode: "default",
    currency: "EUR",
    default_country_id: "GB",
    countries: (IsoCountries) =>
      IsoCountries.registerLocale(require("i18n-iso-countries/langs/en.json")),
  },
  french: {
    locale: "fr-FR",
    url: buildUrl("/fr"),
    magentoStoreCode: "french",
    currency: "EUR",
    default_country_id: "FR",
    countries: (IsoCountries) =>
      IsoCountries.registerLocale(require("i18n-iso-countries/langs/fr.json")),
  },
};
